module.exports = __webpack_public_path__ + "img/number-bg.0a58f5e5.png";